(function () {
  var LIST_ID = 'gnr';
  var LIST_NAME = 'gnr';
  var CURRENCY = 'GBP';
  var viewedCards = new Set();
  var viewBatch = [];
  var viewBatchTimer = null;

  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents);
    }

    return '£' + (cents / 100).toFixed(2);
  }

  function centsToPrice(cents) {
    var value = Number(cents || 0);
    if (!isFinite(value)) return 0;
    return Math.round(value) / 100;
  }

  function getSkuMeta(sku) {
    var map =
      (typeof product_handle_valueMap !== 'undefined' && product_handle_valueMap) ||
      window.product_handle_valueMap ||
      {};
    var values = map[sku];

    if (!values || !values.length) {
      return {
        item_name: '',
        item_variant: 'Sports',
        item_category: '',
        item_category2: ''
      };
    }

    return {
      item_name: values[0] || '',
      item_variant: values[1] || 'Sports',
      item_category: values[2] || '',
      item_category2: values[3] || ''
    };
  }

  function getActiveTrackForm(card) {
    return (
      card.querySelector('.gnr26-product__cart-form.is-active[data-gnr-track-item]') ||
      card.querySelector('.gnr26-product__cart-form[data-gnr-track-item]')
    );
  }

  function buildItemFromForm(form) {
    if (!form) return null;

    var sku = form.dataset.itemId || '';
    var meta = getSkuMeta(sku);
    var price = centsToPrice(form.dataset.itemPrice);
    var discount = centsToPrice(form.dataset.itemDiscount);
    var size = meta.item_category2 || form.dataset.itemSize || 'Standard';
    var color = form.dataset.itemColor || 'none';
    if (color === 'Default Title') color = 'none';

    return {
      item_id: sku,
      item_name: meta.item_name || form.dataset.itemTitle || '',
      discount: discount,
      index: Number(form.dataset.itemIndex || 0) + 1,
      item_list_id: form.dataset.itemListId || LIST_ID,
      item_list_name: form.dataset.itemListName || LIST_NAME,
      item_category: meta.item_category || '',
      item_category2: size,
      item_category3: color,
      item_variant: meta.item_variant || 'Sports',
      item_brand: 'SHOKZ',
      price: price,
      quantity: 1,
      currency: CURRENCY
    };
  }

  function pushGa4Event(eventName, parameters) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event_parameters: null });
    window.dataLayer.push({
      event: 'ga4Event',
      event_name: eventName,
      event_parameters: parameters
    });
  }

  function trackViewItemList(items) {
    if (!items || !items.length) return;

    pushGa4Event('view_item_list', {
      item_list_id: LIST_ID,
      item_list_name: LIST_NAME,
      currency: CURRENCY,
      items: items
    });
  }

  function trackSelectOrCart(eventName, form, buttonName) {
    var item = buildItemFromForm(form);
    if (!item) return;

    var params = {
      item_list_id: LIST_ID,
      item_list_name: LIST_NAME,
      currency: CURRENCY,
      button_name: buttonName,
      items: [item]
    };

    if (eventName === 'add_to_cart') {
      params.value = item.price * item.quantity;
    }

    pushGa4Event(eventName, params);
  }

  function queueViewItem(card) {
    var handle = card.dataset.productHandle || '';
    if (!handle || viewedCards.has(handle)) return;

    var form = getActiveTrackForm(card);
    var item = buildItemFromForm(form);
    if (!item) return;

    viewedCards.add(handle);
    viewBatch.push(item);

    clearTimeout(viewBatchTimer);
    viewBatchTimer = setTimeout(function () {
      trackViewItemList(viewBatch.slice());
      viewBatch = [];
      viewBatchTimer = null;
    }, 300);
  }

  function initViewTracking(section) {
    var cards = section.querySelectorAll('[data-gnr-product-card]');
    if (!cards.length) return;

    if (typeof IntersectionObserver === 'undefined') {
      cards.forEach(queueViewItem);
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;

        var card = entry.target.closest('[data-gnr-product-card]') || entry.target;
        queueViewItem(card);
        observer.unobserve(entry.target);
      });
    });

    cards.forEach(function (card) {
      observer.observe(card.querySelector('[data-gnr-view-sentinel]') || card);
    });
  }

  function getSelectedSize(card) {
    var activeSize = card.querySelector('.toggle-product-size-item.active');
    return activeSize ? activeSize.dataset.optionSize : 'Standard';
  }

  function getSelectedCharging(card) {
    var activeCharging = card.querySelector('.charger-port-item.active');
    return activeCharging ? activeCharging.dataset.optionSize : null;
  }

  function matchesOptionFilters(item, selectedSize, selectedCharging) {
    var itemSize = item.dataset.optionSize || 'Standard';
    var itemCharging = item.dataset.option2 || '';

    if (itemSize !== selectedSize) {
      return false;
    }

    if (selectedCharging && itemCharging && itemCharging !== selectedCharging) {
      return false;
    }

    return true;
  }

  function isColorItemVisible(card, item, selectedSize, selectedCharging) {
    return matchesOptionFilters(item, selectedSize, selectedCharging);
  }

  function setActiveVariant(card, variantId) {
    var images = card.querySelectorAll('.gnr26-product__variant-image');
    var activeImage = null;

    images.forEach(function (image) {
      var isActive = image.dataset.variantId === variantId;
      image.classList.toggle('is-active', isActive);
      if (isActive) {
        activeImage = image;
        if (image.dataset.src && !image.src) {
          image.src = image.dataset.src;
        }
      }
    });

    card.querySelectorAll('.color_list .variant-item').forEach(function (item) {
      var isActive = item.dataset.variantId === variantId;
      item.classList.toggle('active', isActive);
    });

    card.querySelectorAll('.gnr26-product__cart-form').forEach(function (form) {
      form.classList.toggle('is-active', form.dataset.variantId === variantId);
    });

    if (!activeImage) return;

    var priceWrap = card.querySelector('[data-gnr-price]');
    if (!priceWrap) return;

    var current = priceWrap.querySelector('.gnr26-product__price-current');
    var compare = priceWrap.querySelector('.gnr26-product__price-compare');
    var price = Number(activeImage.dataset.variantPrice || 0);
    var comparePrice = Number(activeImage.dataset.variantComparePrice || 0);

    if (current) {
      current.textContent = formatMoney(price);
    }

    if (comparePrice > price) {
      if (!compare) {
        compare = document.createElement('span');
        compare.className = 'gnr26-product__price-compare';
        priceWrap.appendChild(compare);
      }
      compare.textContent = formatMoney(comparePrice);
      compare.hidden = false;
    } else if (compare) {
      compare.remove();
    }

    var activeForm = card.querySelector('.gnr26-product__cart-form.is-active');
    if (!activeForm) return;

    var submitButton = activeForm.querySelector('.gnr26-product__cart-button');
    var isAvailable = activeImage.dataset.variantAvailable === 'true';

    if (submitButton) {
      submitButton.disabled = !isAvailable;
      submitButton.classList.toggle('is-disabled', !isAvailable);
      submitButton.setAttribute('aria-disabled', isAvailable ? 'false' : 'true');
    }
  }

  function syncVisibleColors(card, activateFirst) {
    var selectedSize = getSelectedSize(card);
    var selectedCharging = getSelectedCharging(card);
    var items = card.querySelectorAll('.color_list .variant-item');
    var firstVisible = null;

    items.forEach(function (item) {
      var visible = isColorItemVisible(card, item, selectedSize, selectedCharging);
      item.hidden = !visible;
      if (visible && !firstVisible) {
        firstVisible = item;
      }
    });

    if (activateFirst && firstVisible) {
      setActiveVariant(card, firstVisible.dataset.variantId);
    }
  }

  function initProductCard(card) {
    if (card.dataset.gnrProductReady === 'true') return;

    card.querySelectorAll('.color_list .variant-item').forEach(function (item) {
      item.addEventListener('click', function () {
        if (item.hidden) return;
        setActiveVariant(card, item.dataset.variantId);
      });
    });

    card.querySelectorAll('.toggle-product-size-item').forEach(function (button) {
      button.addEventListener('click', function () {
        button.classList.add('active');
        button.parentElement.querySelectorAll('.toggle-product-size-item').forEach(function (item) {
          if (item !== button) {
            item.classList.remove('active');
          }
        });
        syncVisibleColors(card, true);
      });
    });

    card.querySelectorAll('.charger-port-item').forEach(function (button) {
      button.addEventListener('click', function () {
        button.classList.add('active');
        button.parentElement.querySelectorAll('.charger-port-item').forEach(function (item) {
          if (item !== button) {
            item.classList.remove('active');
          }
        });
        syncVisibleColors(card, true);
      });
    });

    card.querySelectorAll('.gnr26-product__cart-form').forEach(function (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();

        var submitButton = form.querySelector('.gnr26-product__cart-button');
        if (submitButton && submitButton.disabled) return;

        trackSelectOrCart('add_to_cart', form, 'Add to Cart');

        if (typeof ShopifyAPI !== 'undefined' && typeof ShopifyAPI.addItemFromForm2 === 'function' && typeof ajaxCart !== 'undefined') {
          ShopifyAPI.addItemFromForm2(form, ajaxCart.itemAddedCallback, ajaxCart.itemErrorCallback);
          return;
        }

        form.submit();
      });
    });

    card.addEventListener('click', function (event) {
      if (card.dataset.gnrSelectLock === '1') return;

      var target = event.target;
      if (
        target.closest(
          '.gnr26-product__cart-form, .gnr26-product__options, .color_list, .toggle-product-size, .charger-port-part'
        )
      ) {
        return;
      }

      var buttonName = '';
      if (target.closest('.gnr26-product__link')) {
        buttonName = 'Product link button click';
      } else if (target.closest('.gnr26-product__title')) {
        buttonName = 'Product link product name click';
      } else if (target.closest('.gnr26-product__image-link')) {
        buttonName = 'Product link image click';
      } else if (target.closest('.gnr26-product__feature')) {
        buttonName = 'Product link featured image click';
      } else {
        return;
      }

      card.dataset.gnrSelectLock = '1';
      window.setTimeout(function () {
        delete card.dataset.gnrSelectLock;
      }, 400);

      trackSelectOrCart('select_item', getActiveTrackForm(card), buttonName);
    });

    syncVisibleColors(card, false);
    card.dataset.gnrProductReady = 'true';
  }

  function initPromoBanner(section) {
    var promo = section.querySelector('[data-s26-promo]');
    if (!promo || promo.tagName !== 'A') return;

    promo.addEventListener('click', function () {
      pushGa4Event('click_banner', {
        position: '1',
        creative_name: promo.getAttribute('data-promo-creative') || 'gnr',
        creative_slot: 'banner_1',
        button_name: 'learn_more'
      });
    });
  }

  function initProductsSection(section) {
    initPromoBanner(section);
    section.querySelectorAll('[data-gnr-product-card]').forEach(initProductCard);
    initViewTracking(section);
  }

  function initAll() {
    document.querySelectorAll('[data-gnr-products]').forEach(initProductsSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-gnr-products]') || event.target;
    if (section.matches('[data-gnr-products]')) {
      initProductsSection(section);
    }
  });
})();
